<template>
  <div v-if="banners !== null">
    <carousel
      class="home-banner"
      :autoplay="true"
      :items="1"
      :nav="false"
      :animateOut="'fadeOut'"
    >
      <section class="home-banner__item">
        <img
          src="@/assets/banners/banner-1.webp"
          alt
          class="home-banner__item--desktop"
        />
        <img
          src="@/assets/banners/banner-1-mobile.webp"
          alt
          class="home-banner__item--mobile"
        />
        <div class="home-banner__item__text">
          <div class="limit-grid">
            <h1>Campeão na saúde</h1>
            <p>
              Consultas com clínico geral por R$ {{ cdtPrices.clinico_geral }} e
              demais especialidades, R$ {{ cdtPrices.demais }}. Tudo por apenas
              R$ {{ cdtPrices.valor }} mensais para toda a família.
            </p>
            <a
              href="https://torcedores.cartaodetodos.com.br/dados-pessoais/?idserv=27/"
              target="_blank"
              class="home-banner__item__cta"
              @click="handleCTAClick"
              >Solicite seu Cartão</a
            >
          </div>
        </div>
      </section>
      <section class="home-banner__item">
        <img
          src="@/assets/banners/banner-2.webp"
          alt
          class="home-banner__item--desktop"
        />
        <img
          src="@/assets/banners/banner-2-mobile.webp"
          alt
          class="home-banner__item--mobile"
        />
        <div class="home-banner__item__text">
          <div class="limit-grid">
            <h1>Desconto na Loja Cazá do Sport</h1>
            <p>
              Filie-se ao Cartão de TODOS Sport e tenha descontos em produtos na
              loja Cazá da Ilha do Retiro.
            </p>
            <a
              href="https://torcedores.cartaodetodos.com.br/dados-pessoais/?idserv=27/"
              target="_blank"
              class="home-banner__item__cta"
              @click="handleCTAClick"
              >Solicite seu Cartão</a
            >
          </div>
        </div>
      </section>
    </carousel>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import carousel from "vue-owl-carousel";
import { handleCTAClick } from "@/services/gtm";
export default {
  data() {
    return {
      banners: []
    };
  },
  components: { carousel },
  methods: {
    handleCTAClick,
    getBanners() {
      this.$api
        .get(`pages/7`)
        .then(response => {
          this.banners = response.data.acf.banner;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  created() {
    this.getBanners();
  },
  computed: {
    ...mapGetters(["cdtPrices"])
  }
};
</script>

<style lang="scss">
.home-banner {
  position: relative;
  // Media das bordas de banner-1.webp, para a faixa lateral se fundir com a foto
  background-color: #0a0a0a;
  .owl-dots {
    position: absolute;
    bottom: 78px;
    left: 50%;
    transform: translateX(-50%);
    @include media(">=tablet") {
      bottom: 62px;
      left: 62px;
      transform: none;
    }
    @keyframes sizeBar {
      0% {
        width: 0%;
      }
      100% {
        width: 100%;
      }
    }
    .owl-dot {
      outline: none;
      @include media(">=tablet") {
        &:first-child span {
          margin-left: 0;
        }
      }
      span {
        width: 54px !important;
        height: 5px !important;
        border-radius: initial !important;
        background: RGBA(255, 255, 255, 0.5);
        position: relative;
        &::after {
          content: "";
          width: 0%;
          height: 100%;
          background: $color-primary;
          position: absolute;
          top: 0;
          left: 0;
        }
      }
      &.active {
        span {
          &::after {
            animation: sizeBar 5s forwards;
          }
        }
      }
    }
  }
  &__item {
    height: 500px;
    @include media(">=tablet") {
      height: 800px;
    }
    &--desktop {
      display: none !important;
      @include media(">=tablet") {
        display: block !important;
      }
    }
    > a {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: inline-block;
      z-index: 10;
    }

    &--mobile {
      display: block !important;
      @include media(">=tablet") {
        display: none !important;
      }
    }
    img {
      width: 100%;
      height: 100%;
      // Desktop: a foto tem 2732x1200 (proporcao 2,28) e o banner passa de 3,2
      // em tela larga. "cover" preenche a largura inteira, sem faixa lateral, e
      // corta o excedente vertical: em 1920px sao 173px de cada lado, cerca de
      // 12% da altura util. Como a fonte tem o dobro da resolucao exibida, aqui
      // ele reduz a imagem em vez de ampliar, entao nao perde nitidez.
      // Mobile: a arte dedicada tem 360x600 (retrato) e o "cover" corta o
      // excedente vertical para caber nos 500px de altura do item.
      object-fit: cover;
      object-position: 50%;
      @include media(">=tablet") {
        object-position: initial;
      }
    }
    &__cta {
      display: block;
      max-width: 240px;
      margin: 24px auto 0;
      padding: 13px 24px;
      background: $color-secondary;
      color: #000;
      font-family: "Lato", sans-serif;
      font-size: 16px;
      font-weight: 700;
      line-height: normal;
      text-align: center;
      text-decoration: none;
      border-radius: 16px;
      transition: 0.3s ease-in-out;
      &:hover {
        background: $color-red;
      }
      @include media(">=tablet") {
        display: inline-block;
        max-width: none;
        margin: 36px 0 0;
      }
    }
    &__text {
      position: absolute;
      top: 20%;
      left: 0;
      width: 100%;
      @include media(">=tablet") {
        top: 0;
        padding: 62px;

        .limit-grid {
          max-width: none;
          margin: 0;
          padding: 0;
        }
      }

      h1 {
        font-size: 48px;
        line-height: 56px;
        font-family: "Open Sans", sans-serif;
        font-weight: 800;
        color: $color-primary;
        margin-bottom: 11px;
        @include media("<=small") {
          font-size: 22px;
          line-height: 27px;
          text-align: center;
        }
        @include media(">=tablet") {
          font-family: "Open Sans", sans-serif;
          font-size: 60px;
          line-height: 64px;
          max-width: 450px;
          margin-bottom: 8px;
        }
      }

      p {
        max-width: 492px;
        font-weight: 400;
        font-size: 28px;
        line-height: 84px;
        letter-spacing: 0%;
        color: $color-white;
        margin-top: 24px;

        @include media("<=small") {
          margin: 0px auto;
          font-size: 14px;
          text-align: center;
          line-height: 16px;
        }
        @include media(">=tablet") {
          max-width: 450px;
          font-weight: 400;
          font-size: 18px;
          line-height: 28px;
        }
      }
    }
  }
}
</style>
